import { HStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { BlotterErrorIndication } from '@/App/Blotter/BlotterErrorIndication.tsx';
import { ZINDEX_TILE__DRAGGED } from '@/utils/grid/zIndices.ts';

type Props = {
  onTrigger: () => void;
};

export const BlotterTrigger = ({ onTrigger }: Props) => {
  return (
    <HStack
      horizontalAlignment="center"
      className="position-absolute w-100"
      style={{
        bottom: '-3px',
        pointerEvents: 'none', // to allow access to the horizontal scrollbar of the tiles grid
        zIndex: ZINDEX_TILE__DRAGGED + 1, // to ensure that the blotter can be seen when a tile is zoomed
      }}
    >
      <button
        type="button"
        className="btn btn-default btn-icon-end bg-primary-alt d-block"
        style={{
          borderBottomWidth: 'thin',
          pointerEvents: 'all',
        }}
        onClick={onTrigger}
        data-e2e="blotter-trigger-button"
      >
        <FormattedMessage id="blotter.trigger.label" /> <i className="icon">expand_less</i>
        <BlotterErrorIndication />
      </button>
    </HStack>
  );
};
